import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73b12c0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item_worp" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "item_con" }
const _hoisted_4 = { class: "item_info" }
const _hoisted_5 = { class: "info_box" }
const _hoisted_6 = { class: "mon_h" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "价值", -1))
const _hoisted_8 = { class: "i_text" }
const _hoisted_9 = { class: "item_status" }
const _hoisted_10 = { class: "bor_box" }
const _hoisted_11 = { class: "sub_bor" }

import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from '@/api/account';

import { IList } from './type';
import { message } from 'ant-design-vue';
interface IProp {
  dataSource: IList;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CardSquare',
  props: {
    dataSource: null
  },
  setup(__props: any) {

const props = __props as {
  dataSource: IList;
};


const data = ref(props.dataSource);

const isNumColor = computed(() => (data.value.type === 5 ? 'invalid_color' : data.value.type === 1 ? 'cash_color' : 'add_color'));
const isTitleColor = computed(() =>
  data.value.type === 1 ? 'cash_color' : data.value.type === 4 ? 'add_color1' : data.value.type === 5 ? 'experien_color' : ''
);
const isUseColor = computed(() =>
  data.value.type === 1 ? 'cash_color' : data.value.type === 4 ? 'add_color1' : 'experien_color'
);
const isTextColor = computed(() =>
  data.value.type === 1 ? 'cash_color1' : data.value.type === 4 || data.value.type === 5 ? 'add_color2' : ''
);
const isWhiteColor = computed(() => (data.value.status === 0 ? 'invalid_color' : ''));

const router = useRouter();
const use_card = () => {
  axios
    .use_card({ params: { coupon_id: data.value.id } })
    .then(() => {
      router.push('/wallet/overview');
    })
    .catch((err) => message.error(err?.data?.error));
};
const clickUse = () => {
  if (data.value.cardId === 11) {
    use_card();
  } else {
    router.push('/wallet/recharge');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: data.value.background
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["i_mon", [_unref(isNumColor), _unref(isWhiteColor)]])
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", null, _toDisplayString(data.value.pirce), 1),
              _createTextVNode("元 ")
            ]),
            _hoisted_7
          ], 2),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass([_unref(isTitleColor), _unref(isWhiteColor)])
            }, _toDisplayString(data.value.title), 3),
            _createElementVNode("div", {
              class: _normalizeClass(["t_sub", [_unref(isTextColor), _unref(isWhiteColor)]])
            }, _toDisplayString(data.value.describe), 3)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (data.value.status === 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["s_text", [_unref(isUseColor)]]),
              onClick: clickUse
            }, "立即使用", 2))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["s_bor", { s_bor1: data.value.status !== 0 }])
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(data.value.status === 0 ? '已失效' : '已使用'), 1)
              ])
            ], 2))
      ])
    ])
  ]))
}
}

})